"use client"

import type React from "react"
import { Snackbar, Alert } from "@mui/material"

interface CustomizedSnackbarProps {
  open: boolean
  message: string
  severity: "success" | "error" | "warning" | "info"
  onClose: (event?: React.SyntheticEvent | Event, reason?: string) => void
  autoHideDuration?: number
}

const CustomizedSnackbar: React.FC<CustomizedSnackbarProps> = ({
  open,
  message,
  severity,
  onClose,
  autoHideDuration = 4000,
}) => {
  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    onClose(event, reason)
  }

  const handleAlertClose = (event: React.SyntheticEvent) => {
    event.preventDefault()
    event.stopPropagation()
    onClose(event, "close")
  }

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      sx={{
        '& .MuiPaper-root': {
          maxWidth: '400px',
          width: '100%',
        }
      }}
    >
      <Alert 
        onClose={handleAlertClose} 
        severity={severity} 
        variant="filled" 
        sx={{ 
          width: '100%',
          maxWidth: '300px',
          '& .MuiAlert-message': {
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            display: 'flex',
            alignItems: 'center',
          }
        }}
      >
        {typeof message === 'string' ? message : String(message)}
      </Alert>
    </Snackbar>
  )
}

export default CustomizedSnackbar